/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';
import '@wwdev/bootstrap/index.js';
import '@fancyapps/fancybox';
// import wwdev from '@wwdev/functions'; // to load all functions; all functions are bound to wwdev. example: wwdev.getResponsiveWidth()
// import getResponsiveWidth from '@wwdev/functions/getResponsiveWidth'; // to load single function. preffered to reduce code size
jQuery('.fancybox').fancybox();
import '@wwdev/search';


import '@wwdev/functions/index.js';
import './wwdev/forms/index';
import Form from "@wwdev/winkelwagen/form"
import './base/zipcodeForm.js';
import './base/cookiebar.js';

import './wwdev/lazysizes/index.js';
// import './wwdev/webshop/index.js';
import '@wwdev/product';
import '@wwdev/contentable';
import './vendor/overview-filter';
import './vendor/fieldService'
import './vendor/contentlist/detail'
import Grid from './vendor/download/grid';
$(document).ready(() => Grid.init());
import './vendor/download/contentable'

import './base/pageHeight.js';
import './base/header.js';
import './base/footer.js';
import './base/form.js';
import './base/mobileOnly.js';
import './base/sidemenu';
import './base/corporate';

import './components/slider.js';

import './pages/_1column.js';

import './externals/flickity/index.js';
import './components/map';
import './sections/webshop.js';

